import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { FeelingContext } from '../../@types/ai-api';
import styles from './FeelingAIModal.module.scss';
import ChatPage from '../../components/Chat/ChatPage';
import {
  ChatSuggestion,
  ContextQuestion,
  ContextQuestionResponse,
} from '../../components/Chat/ChatDialog';
type Props = {
  show: boolean;
  mode?: string;
  initiationText: string;
  suggestions?: ChatSuggestion[];
  contextQuestions?: ContextQuestion[];
  disableFreeText?: boolean;
  onClose: (text?: string) => void;
  getFeelingContext?: (
    data: ContextQuestionResponse[]
  ) => FeelingContext | undefined;
};

const FeelingAIModal: FC<Props> = ({
  show,
  onClose,
  mode,
  initiationText,
  getFeelingContext,
  suggestions,
  disableFreeText,
  contextQuestions,
}) => {
  const handleClose = (text?: string) => {
    onClose(text);
  };
  return (
    <Modal className={styles.root} show={show} onHide={handleClose}>
      <ChatPage
        onClose={handleClose}
        embedded
        mode={mode}
        initiationText={initiationText}
        getFeelingContext={getFeelingContext}
        suggestions={suggestions}
        disableFreeText={disableFreeText}
        contextQuestions={contextQuestions}
      />
    </Modal>
  );
};

export default FeelingAIModal;
